import * as React from 'react';

/**
 * Higher Order Component that renders the wrapped component with the given key (derived from its
 * props), which allows us to easily "reset" a component if certain props change.
 * @param component
 * @param getKey
 */
export function KeyOn<P>(
  component: React.ComponentType<P>, getKey: (props: P) => string
): React.ComponentType<P> {
  const componentName = component.displayName ?? (component as React.FC).name ?? 'unknown';
  const displayName = `KeyOn(${componentName})`;
  const hoc = (props: P) => {
    const key = getKey(props);
    return React.createElement(component, { ...props, key });
  };
  hoc.displayName = displayName;
  return hoc;
}
